/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */

// import utils
import useSWR from "swr";

// import client
import client from "@/axiosClient";

// import types
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import type { SWRConfiguration } from "swr";

export type SWRConfig<Response> = SWRConfiguration<Response> & { shouldFetch?: boolean };

export const useGet = <Response = unknown,>(
  requestConfig: AxiosRequestConfig = {},
  { shouldFetch, ...swrConfig }: SWRConfig<AxiosResponse<Response>> = {},
) => {
  const _shouldFetch = shouldFetch ?? true;

  return useSWR<AxiosResponse<Response>, AxiosError<unknown>>(
    () => (_shouldFetch ? [requestConfig.url, requestConfig.params] : null),
    () => client(requestConfig),
    swrConfig,
  );
};

export default useGet;
